import { useState } from 'react';
import AreaName from './components/AreaName/AreaName';

export interface CategorizedData {
  [key: string]: {
    [key: string]: Object[];
  };
}

function App() {
  // for Professional Curriculum
  const [areaNames] = useState<string[]>([
    'Fundamentals',
    'Emerging Issues',
    'Engine Performance',
    'Diesel Engine Performance',
    'Engine Repair',
    'Electrical/Electronics',
    'Manual Drivetrain & Axle',
    'Automatic Transaxle/Transmission',
    'Brakes',
    'Steering & Suspension',
    'HVAC',
    'Mech/Elec/Body Repair',
    'EV Expert',
    'EV Master',
    'Body Structural Repair (I-CAR)',
    'Paint',
  ]);

  // for Technical Foundation Curriculum
  // const [areaNames] = useState<string[]>([
  //   'Fundamentals - Tech Apprentice (Display Only)',
  // ]);
  return (
    <>
      {areaNames.map((areaName: string) => {
        return <AreaName key={areaName} name={areaName} />;
      })}
    </>
  );
}

export default App;
